<template>
  <transition name="slide-up">
    <div v-if="value" id="toast-container" @click.prevent="$emit('input', false)">
      <div class="toast" style="top: 0px; opacity: 1" :class="toastClass">
        <span>{{ text }}</span>
        <button v-if="actionLabel" class="btn-flat white-text toast-action" @click.prevent="$emit('action-click')">
          {{ actionLabel }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    actionLabel: {
      type: String,
      default: '',
    },
    displayLength: {
      type: Number,
      default: 5000,
    },
  },
  data: () => ({
    timeout: null,
  }),
  computed: {
    toastClass() {
      return { 'teal': this.type === 'success', 'grey lighten-2 red-text text-accent-2': this.type === 'error' };
    },
  },
  watch: {
    async value(newval) {
      if (!newval) return;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit('input', false);
      }, this.displayLength);
    },
  },
};
</script>

<style lang="scss" scoped>
#toast-container {
  bottom: 57px;
  .toast {
    padding: 12px 24px;
    box-shadow: 0px -5px 5px rgba(0, 0, 0, 0.2);
    .toast-action {
      color: #eeff41;
      font-weight: 500;
      margin-right: 0;
      margin-left: 0;
      margin-right: -12px;
    }
  }
}
</style>
